/**
 * Created by Suhel Shrestha on 6/4/19
 */

import { computed } from 'mobx';

export default class DataOriginParameterTemplateModel {
  id;
  store;

  constructor(store, daqProcessor) {
    this.store = store;
    this.id = +daqProcessor.id;
    this.name = daqProcessor.name;
    this.parameter_id = daqProcessor.parameter_id;
    this.code = daqProcessor.code;
    this.parameters = daqProcessor.parameters;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      parameter_id: this.parameter_id,
      code: this.code,
      parameters: this.parameters,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.parameter_id = json.parameter_id;
    this.code = json.code;
    this.parameters = json.parameters;
  }
}



// WEBPACK FOOTER //
// ./src/models/DataOriginParameterTemplateModel.js